<template>
  <div class="detail-container">
    <div class="appeals-detail-box columns is-multiline is-centered is-12">
      <div class="column is-9">
        <div 
          class="appeals-title has-text-weight-bold"
          v-if="detailInfo.appealsType !== null"
        >
            {{ detailInfo.appealsType }}
        </div>
        <div class="appeals-number is-size-2">Appeal Number <b> {{ detailInfo.appealsNumber }} </b></div>
        <div
          class="appeals-address has-text-weight-bold"
        >
         L&I District:  {{this.$store.state.searchResults.li_district}}
        </div>
        <div
          class="appeals-address has-text-weight-bold"
        >
         OPA Account #:  {{this.$store.state.detailPage.opa_account_num}}
        </div>
        <div 
          class="appeals-address"
          v-for="item in detailInfo.appealsAddress"
          :key="item"
        >
          <div class="multi-cell">
            {{ item }} 
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="appeals-date has-text-weight-bold">{{ detailInfo.appealsStatus }} </div>
        <div class="bottom-right-link">
          <a
            target="_blank"
            :href="appealTypeLink"
          >
            {{ isZbaAppeal ? 'ZBA Appeals Calendar' : 'Appeals Calendar' }}<i class="fa fa-external-link" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>

  <div
    class="detail-table-container columns is-multiline is-centered is-12"
  >
    <v-client-table 
      class="table-light no-header column is-12"
      :data="tableData" 
      :columns="columns" 
      :options="options"
    >
      <template
        slot="appealTableInfo"
        slot-scope="{row}"
        class="multi-cell"
      >

      <!-- single-line cell template -->
      <div v-if="(typeof row.appealTableInfo === 'string') && (row.id !== 'Zoning documents')">
        <div
          class="multi-cell"
        >
          {{ row.appealTableInfo }}
        </div>
      </div>

      <!-- multi-line cell template -->
      <div 
        v-if="(typeof row.appealTableInfo === 'object') && (row.id !== 'Zoning documents')"
      >
        <div 
          v-for="item in row.appealTableInfo"
          :key="item"
        >
          <div
            class="multi-cell"
          >
            {{ item }} 
          </div>
        </div>
      </div>
      </template>
    </v-client-table>

      <div 
        class="appeals-accordion-container column is-12"
        v-if="appealsCourtHistory"
      >
        <h3 class="has-text-weight-bold">Hearing Decisions History</h3>
        <Accordion 
          :contents="courtHistory"
          class="appeals-accordion"
        >
          <div 
            slot-scope="{ item }"
          >
            <v-client-table 
              class="table-light no-header"
              :data="appealsTableData({item})" 
              :columns="columns" 
              :options="options"
            >
              <template
                slot="name"
                slot-scope="{row}"
                class="multi-cell"
              >

                <!-- single-line cell template -->
                <div v-if="typeof row.name === 'string'">
                  {{ row.name }}
                </div>

                <!-- multi-line cell template -->
                <div 
                  v-if="(typeof row.name === 'object') && (row.id !== 'Zoning documents')"
                >
                  <div 
                    v-for="item in row.name"
                    :key="item"
                  >
                    <div class="multi-cell">
                      {{ item }} 
                    </div>
                  </div>
                </div>
              </template>
            </v-client-table>
          </div>
        </Accordion>
      </div>

      <div 
        class="zba-accordion-container column is-12"
        v-if="(typeof this.$store.state.zoningBoardHistory !== 'undefined')"
      >
        <h3 class="has-text-weight-bold">Appeal History</h3>
        <Accordion
          v-if="zbaReady"
          :contents="zbaHistory"
          class="appeals-accordion"
        >
          <div 
            slot-scope="{ item }"
          >
            <v-client-table 
              class="table-light no-header"
              :data="zbaTableData({item})" 
              :columns="columns" 
              :options="options"
            >
              <template
                slot="name"
                slot-scope="{row}"
                class="multi-cell"
              >

                <!-- single-line cell template -->
                <div v-if="typeof row.name === 'string'">
                  {{ row.name }}
                </div>

                <!-- multi-line cell template -->
                <div 
                  v-if="(typeof row.name === 'object') && (row.id !== 'Zoning documents')"
                >
                  <div 
                    v-for="item in row.name"
                    :key="item"
                  >
                    <div class="multi-cell">
                      {{ item }} 
                    </div>
                  </div>
                </div>
              </template>
            </v-client-table>
          </div>
        </Accordion>
      </div>
    </div>

  </div>
</template>

<script>

import Accordion from '@/components/Accordion';
import moment from 'moment';

export default {
  name: 'appealsDetail',
  components: {
    Accordion, 
  },
  data() {
    return {
      zbaReady: false,
      columns: ['id', 'appealTableInfo'],
      detailInfo: this.$store.state.detailPage,
      resultsAccordion: {
        columns: ['id', 'text'],
        options: {
          filterable: false,
          sortable: [],
          highlightMatches: false,
          pagination: { 
            show: false, 
            virtual: false,
          },
          perPage: 100,
          columnsClasses: {
            id: 'appeals-detail table-id has-text-weight-bold',
            name: 'table-name',
          },
        },
      },
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        pagination: { 
          show: false, 
          virtual: false,
        },
        perPage: 100,

        columnsClasses: {
          id: 'appeals table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
    }
  },
  mounted(){
    this.$store.dispatch('getZoningBoardHistory', this.detailInfo.appealsNumber);
    this.$store.dispatch('getAppealsCourtHistory', this.detailInfo.appealsNumber);
    return this.$data.zbaReady = true;
  },
  destroyed() {
    this.$store.commit('closeDetail');
  },
  computed: {
    appealsCourtHistory(){
      return this.$store.state.appealsCourtHistory
    },
    // zoning appeals are heard on the ZBA calendar; every other type links to the L&I calendar
    isZbaAppeal(){
      return ['Zoning Board of Adjustment', 'RB_ZBA'].includes(this.$store.state.detailPage.applicationtype)
    },
    appealTypeLink(){
      let appeal = this.$store.state.detailPage
      let calendar = this.isZbaAppeal ? '/zba-appeals-calendar' : '/appeals-calendar'
      if (!appeal.scheduleddate) {
        return calendar + '?region=all&keyword=' + appeal.appealsNumber
      }
      let schedDate = moment(appeal.scheduleddate).format('MM-DD-yyyy')
      let schedDateEnd = moment(appeal.scheduleddate).add(1, 'days').format('MM-DD-yyyy')
      return calendar + '?from=' + schedDate + '&to=' + schedDateEnd + '&region=all&keyword=' + appeal.appealsNumber
    },
    getMailingAddress(){
      if(this.$store.state.mailingAddress) {
        let mailingData = this.$store.state.mailingAddress;
        let mailingArray = [];
        if(mailingData.mailing_address_1){
          mailingArray.push.apply(mailingArray, [mailingData.mailing_address_1, mailingData.mailing_address_2])
        } else {
          mailingArray.push(mailingData.mailing_street)
        }
        mailingArray.push(mailingData.mailing_city_state + " " + mailingData.mailing_zip)
        return mailingArray
      } else {
        return []
      }
    },
    tableData(){
      let prop = this.detailInfo;
      let tableInfo = [
        { id: "Appeal number", 
          appealTableInfo: prop.text
        },
        { id: "Grounds", 
          appealTableInfo: prop.appealsGrounds
        },
        { id: "Primary applicant", 
          appealTableInfo: prop.appealsPrimaryAppellant
        },
        { id: "Permit number", 
          appealTableInfo: prop.appealsPermitNumber
        },
      ];
      if (prop.coordinatingrco) {
        tableInfo.push({
          id: "Coordinating RCO",
          appealTableInfo: prop.coordinatingrco
        });
      }
      return tableInfo;
    },
    courtHistory(){
      let item = [];
      if(this.$store.state.appealsCourtHistory){
        this.$store.state.appealsCourtHistory.forEach(
          a => {
          // console.log(a);
          let appealRecord = new Object();
          appealRecord.title = a.courtcasenumber;
          appealRecord.date = moment(a.courtactiondate).isValid() ? moment(a.courtactiondate).format('dddd, MMM DD, yyyy') : "Not Available";
          appealRecord.decision = a.courtresult;
          appealRecord.provisio = a.courtproviso;
          item.push(appealRecord);
          }
        );
      }
      return item;
    },
    zbaHistory(){
      let item = [];
      if(this.$store.state.zoningBoardHistory){
        this.$store.state.zoningBoardHistory.forEach(
          a => {
          // console.log(a);
          let zbaRecord = new Object();
          zbaRecord.title = moment(a.decisiondate).format('dddd, MMM DD, yyyy');
          zbaRecord.date = moment(a.decisiondate).format('dddd, MMM DD, yyyy')
          zbaRecord.decision = a.decision;
          zbaRecord.remarks = a.meetingremarks;
          item.push(zbaRecord);
          }
        );
      }
      return item;
    }
  },
  methods: {
    clickBackButton(){
      this.$store.commit('closeDetail');
    },
    appealsTableData({item}){
      // console.log(item)
      const constItem = item;
      let tableData = [];
      const idList = ['date', 'decision', 'provisio'];
      idList.forEach( each => {
        // console.log(each)
        let row = new Object();
        row.id = each
        row.appealTableInfo = constItem[each]
        tableData.push(row);
      });
      // console.log("Table data for appeals: ", tableData)
      return tableData;
    },
    zbaTableData({item}){
      // console.log(item)
      const constItem = item;
      let tableData = [];
      const idList = ['decision', 'remarks'];
      idList.forEach( each => {
        // console.log(each)
        let row = new Object();
        row.id = each
        row.appealTableInfo = constItem[each]
        tableData.push(row);
      });
      // console.log("Table data for appeals: ", tableData)
      return tableData;
    },
  },
}
</script>
<style lang="scss">

@media screen and (max-width: 768px) {
  .appeals-detail-box>div.is-3 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    div.appeals-date, .bottom-right-link {
      text-align: left;
      flex: 100%;
    }
    .bottom-right-link {
      float: right;
    }
  }
}

.detail-container {
  margin-top: 4rem;
  background-color: white;
  margin: auto;
}

.detail-button {
  margin-top: 20px;
}

.no-header th {
  display: none !important;
}

//  CSS for grey header-box in appeals detail page
.detail-container .appeals-detail-box, .detail-container .zba-detail-box  {
  background-color: $ben-franklin-blue-light;
  margin: 0;
  clear: both;
  padding: 15px 5px 15px 25px;
  position: relative;
  // & .column {
  //   padding: 0;
  // }
  .appeals-title {
    text-transform: uppercase;
  }
  .appeals-number {
    text-transform: uppercase;
    padding: 5px 0 15px 0;
  }
  .appeals-date {
    text-align: right;
    // padding-right: 15px;
  }
  .bottom-right-link {
    right: 15px;
    bottom: 15px;
  }

}

.appeals-accordion-container, .zba-accordion-container {
  margin-top: 35px;
  margin: auto;
}

.appeals-accordion>div.accordion-question {
  padding: 0 15px;
  background: $ghost-grey;
  border-bottom: none;
  border-spacing: 0 14px;
  border-collapse: separate;
} 

.appeals-accordion .table-light {
  th, tr, td {
    background: $ghost-grey;
  }
}

.accordion-question {
  margin-bottom: 25px;
}

.appeals-accordion .accordion-question .accordion-content .contents-div {
  width: 100%;
}

.appeals.table-id.has-text-weight-bold {
  text-transform: capitalize;
}

.table-id.has-text-weight-bold {
  width: 35%;
}

div.is-pulled-right.VueTables__limit {
   display: none;
}

.detail-table-container.columns:last-child {
  margin-bottom: .75rem !important;
}

</style>